import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ClientLogo = styled.img`
  width: auto;
  display: block;
  flex: 0;
  margin: 0 auto;
`;

const ClientLogoContainer = styled.div`
  @media (max-width: 767px) {
    margin: 1.5rem auto;
    min-width: 33.33333333%;
  }

  @media (max-width: 576px) {
    width: 100%;
    margin: 1rem auto;
  }
`;

const ClientLogoList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  @media (max-width: 767px) {
    justify-content: space-around;
    flex-wrap: wrap;
  }
`;

export const ClientLogos = ({ logos }) => (
  <ClientLogoList>
    {logos.map((logo, i) => (
      <ClientLogoContainer className="" key={i}>
        <ClientLogo src={logo.src} alt={logo.alt} />
      </ClientLogoContainer>
    ))}
  </ClientLogoList>
);

ClientLogos.propTypes = {
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    })
  ).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/styled/ClientLogos.js